import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { postPrecheckTransaction, getPlantByCode } from '../../services/APIs';
import { PrecheckContext } from '../../contexts/PrecheckContext';
import { CustomModalContext } from '../../contexts/CustomModalContext';
import { FormattedMessage } from 'react-intl';

const TAC = [
    { id: 'termsAndConditionsOne', default: ' My trailer is in good condition.' },
    { id: 'termsAndConditionsTwo', default: ' My trailer is clean and free from debris and Odor.' },
    { id: 'termsAndConditionsThree', default: 'My trailer has a door to lock.' },
    { id: 'termsAndConditionsFour', default: 'I will slide back my tandems when before docking.' },
    {
        id: 'termsAndConditionsFive',
        default: 'I will ensure that my trailer is open prior to docking.'
    },
    {
        id: 'termsAndConditionsSix',
        default:
            'I will properly restrain my trailer such that it remains in place during loading (e.g. ensuring the dock lock is engaged).'
    },
    {
        id: 'termsAndConditionsSeven',
        default:
            'I will not smoke nor engage in any unsafe, illegal or offensive behavior while on the premises.'
    },
    { id: 'termsAndConditionsEight', default: ' I will abide by all Niagara facility policies.' },
    {
        id: 'termsAndConditionsNine',
        default:
            'Niagara is not responsible for costs, claims and liabilities associated with my failure to comply with the foregoing.'
    }
];

const TermsAndConditions = () => {
    const Navigate = useNavigate();
    const { precheckInfo, orderInfo, setPrecheckInfo } = useContext(PrecheckContext);
    const { showModal, showNetworkErrorModal } = useContext(CustomModalContext);

    const onSubmit = async () => {
        try {
            const cachedOrgCode = localStorage.getItem('orgCode');
            const plantResponse = await getPlantByCode(cachedOrgCode as string);
            console.log(plantResponse.data.plant._id);

            const response = await postPrecheckTransaction(
                precheckInfo.submittedName,
                precheckInfo.submittedPhoneNumber,
                precheckInfo.submittedReferenceId,
                precheckInfo.submittedDotNumber,
                precheckInfo.plantId || plantResponse.data.plant._id,
                precheckInfo.orgCode,
                precheckInfo.submittedVisitType,
                precheckInfo.language,
                precheckInfo.hasTrailer,
                precheckInfo.submittedTrailerNumber,
                precheckInfo.submittedTrailerLength,
                precheckInfo.isOrderFound,
                orderInfo.manhTripId,
                orderInfo.manhDeliveryId,
                orderInfo.manhCustomerPo,
                orderInfo.manhCarrierName,
                orderInfo.manhCarrierSCAC,
                orderInfo.manhCustomerName,
                orderInfo.manhAddress,
                orderInfo.manhVisitType,
                orderInfo.manhPickupAppointment,
                orderInfo.manhDeliveryAppointment
            );
            if (response.code === 'ERR_NETWORK') {
                showNetworkErrorModal();
                return;
            }

            if (response.status === 201) {
                setPrecheckInfo({ ...precheckInfo, precheckId: response.data.precheck._id });
                Navigate('/report');
                return;
            }
            showModal({
                title: 'Error',
                subtitle: response.response.data.error,
                buttonOneText: 'Ok'
            });
            return;
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            <p className="fs-6 m-4">
                <FormattedMessage
                    id="termsAndConditionsSubTitle"
                    defaultMessage="I acknowledge and agree that:"
                />
            </p>
            <div className="m-4 bg-white rounded border border-dark center-text">
                <div className="d-flex flex-column justify-content-evenly vw-80 my-4 mx-1">
                    <ul>
                        {TAC.map((elm) => {
                            return (
                                <li className="my-1" key={elm.id}>
                                    <FormattedMessage id={elm.id} defaultMessage={elm.default} />
                                </li>
                            );
                        })}
                    </ul>
                </div>
                <div className="d-flex flex-row justify-content-center">
                    <button className="btn md-button m-2 " onClick={onSubmit}>
                        <FormattedMessage id="submit" defaultMessage="Submit" />
                    </button>
                </div>
            </div>
        </>
    );
};

export default TermsAndConditions;
